import React, { ReactElement } from 'react';

import { classNames } from 'utils/css';

import { THeaderProps } from './Header.types';
import styles from './Header.module.scss';

function Header({
  tabRefs,
  tabs,
  onTabChange,
  selectedTab,
}: THeaderProps): ReactElement {
  const selectedTabHeaderClass = classNames(
    styles.headerButton,
    styles.selected
  );

  const tabHeaderClass = classNames(styles.headerButton);

  return (
    <div
      className={styles.headersWrapper}
      data-testid="TabHeader"
      role="tablist">
      {tabs.map((tab, index) => {
        const currentTabSelected = tab.key === selectedTab.key;
        return (
          <button
            aria-selected={currentTabSelected}
            role="tab"
            aria-controls={`panel-${tab.key}`}
            tabIndex={currentTabSelected ? 0 : -1}
            id={`tab-${tab.key}`}
            data-testid="TabButton"
            key={tab.key}
            ref={tabRefs[index]}
            type="button"
            className={
              currentTabSelected ? selectedTabHeaderClass : tabHeaderClass
            }
            onClick={() => {
              onTabChange(tab.key);
            }}>
            {tab.header}
          </button>
        );
      })}
    </div>
  );
}

export default Header;
